import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TeamPlayer from '../TeamPlayer';
import EmptyPlayer from '../EmptyPlayer';

const Team = (props) => {
  const {
    players,
    giftsAlign,
    activePlayerId,
    playerId,
    onVoteForKickClicked,
    onSendGiftClicked,
    onSelectPlayer,
    clearNotes,
    streamId,
    videoService,
    subscribedStreams,
    user,
    hasGifts,
    isAudiencePlayer,
    isGameFinished,
    isInterstitialPlaying,
    isVideoPlaying,
  } = props;
  const renderTeamPlayer = player => (player ?
    <TeamPlayer
      key={player.id}
      giftsAlign={giftsAlign}
      activePlayerId={activePlayerId}
      playerId={playerId}
      onVoteForKickClicked={onVoteForKickClicked}
      onSendGiftClicked={onSendGiftClicked}
      onSelectPlayer={onSelectPlayer}
      clearNotes={clearNotes}
      streamId={streamId}
      videoService={videoService}
      subscribedStreams={subscribedStreams}
      user={user}
      hasGifts={hasGifts}
      isAudiencePlayer={isAudiencePlayer}
      isGameFinished={isGameFinished}
      isInterstitialPlaying={isInterstitialPlaying}
      isVideoPlaying={isVideoPlaying}
      {...player}
    /> :
    <EmptyPlayer key="empty"/>
  );
  const teamClasses = classNames(
    'team',
    {
      [`team_${giftsAlign}`]: Boolean(giftsAlign),
    }
  );

  return (
    <div className={teamClasses}>
      {players.map(renderTeamPlayer)}
    </div>
  );
};

Team.propTypes = {
  players: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  giftsAlign: PropTypes.string.isRequired,
  activePlayerId: PropTypes.string,
  playerId: PropTypes.string,
  onVoteForKickClicked: PropTypes.func.isRequired,
  onSendGiftClicked: PropTypes.func.isRequired,
  onSelectPlayer: PropTypes.func.isRequired,
  clearNotes: PropTypes.func.isRequired,
  streamId: PropTypes.number,
  videoService: PropTypes.func.isRequired,
  subscribedStreams: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({}).isRequired,
  hasGifts: PropTypes.bool.isRequired,
  isAudiencePlayer: PropTypes.bool.isRequired,
  isGameFinished: PropTypes.bool,
  isInterstitialPlaying: PropTypes.bool.isRequired,
  isVideoPlaying: PropTypes.bool.isRequired,
};

Team.defaultProps = {
  streamId: null,
  activePlayerId: null,
  isGameFinished: false,
};

export default Team;
